import { useQuery } from "@tanstack/vue-query";
import Billing from "@/services/billing/billing";

export function usePaymentMethods() {
  return useQuery({
    queryKey: ["billing", "paymentMethods"] as const,
    queryFn: async () => {
      const result = await Billing.getPaymentMethods();
      const payload = result?.data as { status?: boolean; data?: unknown };
      if (payload?.status && payload?.data != null) return payload.data;
      return { payment_methods: [] };
    },
    staleTime: 0,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
}
